const oddPredicate = (i: number) => Boolean(i % 2);
const evenPredicate = (i: number) => !Boolean(i % 2);

export const evenSplit = [evenPredicate, oddPredicate];